import type { SettingsResponse } from "../../shared/types";
import { Button } from "../components/ui/Button";
import { Pill } from "../components/ui/Pill";
import { FromFlashsuite, LookPickers, usePreviewWho } from "../setup/parts";
import { PreviewPanel, usePreviewRoom } from "../setup/Previews";
import type { Run } from "../setup/useSettingsData";
import { SettingsHead } from "./SettingsView";
import { useBrandDraft } from "../setup/useBrandDraft";

/** Settings > Brand: the colours and the email identity, drawn live, saved together from the bar at the bottom. */
export function BrandPane({ data, run }: { data: SettingsResponse; run: Run }) {
  const room = usePreviewRoom();
  const who = usePreviewWho(data, room);
  const { draft, dirty, saving, save, discard, pick, setFromName, setFooter } = useBrandDraft(data, run);
  const previewWho = { ...who, fromName: draft.fromName || who.business, footer: draft.footer };
  return (
    <>
      <SettingsHead eyebrow="Appearance" title="Brand" />
      <div className="brandlyt">
        <div className="col" style={{ gap: 20 }}>
          <section className="card">
            <div className="card-b col" style={{ gap: 20 }}>
              <FromFlashsuite business={who.business} logoUrl={data.brand.logo_url} />
              <LookPickers mode={draft.mode} colours={draft.colours} onPick={pick} />
            </div>
          </section>
          <section className="card">
            <div className="card-h">
              <div>
                <h2>Email identity</h2>
              </div>
            </div>
            <div className="card-b col" style={{ gap: 14 }}>
              <div className="field">
                <label htmlFor="br-from">From name</label>
                <input dir="auto" id="br-from" className="inp" value={draft.fromName} onChange={(e) => setFromName(e.target.value)} />
              </div>
              <div className="field">
                <label htmlFor="br-footer">Email footer</label>
                <textarea dir="auto" id="br-footer" className="inp" rows={3} value={draft.footer} onChange={(e) => setFooter(e.target.value)} />
                <div className="hint">An unsubscribe link is added after it.</div>
              </div>
            </div>
          </section>
        </div>
        <div className="pvcol">
          <section className="card pad">
            <div className="row" style={{ marginBottom: 12 }}>
              <h2 className="h2 sp">Live preview</h2>
              {dirty ? (
                <Pill tone="brass" dot>
                  Not saved yet
                </Pill>
              ) : null}
            </div>
            <PreviewPanel colours={draft.colours} who={previewWho} />
          </section>
        </div>
      </div>
      {dirty ? (
        <div className="savebar" role="region" aria-label="Unsaved changes">
          <span className="sp b6">Unsaved changes</span>
          <Button size="s" className="ghost" onClick={discard}>
            Discard
          </Button>
          <Button size="s" variant="p" disabled={saving} onClick={() => void save()}>
            Save changes
          </Button>
        </div>
      ) : null}
    </>
  );
}
